var _ellipse, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 13.125,
    rx: 5.25,
    ry: 2.625,
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 5.25,
    r: 3,
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3079 7.64904C11.0541 8.05111 10.7383 8.41019 10.374 8.71287C10.65 8.80192 10.9444 8.85003 11.25 8.85003C12.824 8.85003 14.1 7.57404 14.1 6.00003C14.1 4.50551 12.9497 3.27966 11.4861 3.15967C11.7031 3.57267 11.8578 4.02353 11.9378 4.49975C12.5057 4.7605 12.9 5.33421 12.9 6.00003C12.9 6.89192 12.1924 7.61854 11.3079 7.64904Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2501 13.1262C14.2498 13.6189 14.1083 14.0913 13.8488 14.5293C14.1404 14.4506 14.4132 14.3586 14.6628 14.2546C15.1134 14.0669 15.5172 13.8281 15.8175 13.5322C16.1199 13.2343 16.3501 12.8428 16.3501 12.3749C16.3501 11.907 16.1199 11.5156 15.8175 11.2177C15.5172 10.9218 15.1134 10.683 14.6628 10.4953C13.8711 10.1654 12.8467 9.9566 11.7295 9.90991C12.5419 10.3095 13.1997 10.8218 13.6393 11.4079C13.8427 11.4665 14.0308 11.5319 14.2013 11.603C14.5651 11.7545 14.8203 11.9198 14.9754 12.0725C15.1284 12.2233 15.1501 12.3251 15.1501 12.3749C15.1501 12.4248 15.1284 12.5266 14.9754 12.6773C14.8273 12.8232 14.588 12.9804 14.2501 13.1262Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/teamIcon.51b8fb53eb2b9a6bb8b4b089bf2647af.svg";
export { ForwardRef as ReactComponent };